import { render, staticRenderFns } from "./SaleOrders.vue?vue&type=template&id=81fc0562&scoped=true"
import script from "./SaleOrders.vue?vue&type=script&lang=js"
export * from "./SaleOrders.vue?vue&type=script&lang=js"
import style0 from "./SaleOrders.vue?vue&type=style&index=0&id=81fc0562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fc0562",
  null
  
)

export default component.exports